module.exports = __webpack_public_path__ + "img/debbe24.jpg";